import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import moment from 'moment'
import { Flex } from 'components/shared/flex'
import { ThemeContext } from 'contexts/theme_context'
import { Button, Table } from 'react-bootstrap'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { DateField, SelectField } from 'components/shared/input'
import { selectYears } from 'utils/util'
import { SalesSearchForm, useDownloadSalesApi, useFetchSalesApi } from 'api/sales'
import { ModalButton } from 'components/shared/widget'
import { SalesDetailSearchForm, useDownloadSalesDetailApi } from 'api/sales_detail'

type Props = {
    history: H.History
}

const SalesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const theme = useContext(ThemeContext)
    const salesDetailSearchForm = useForm<SalesDetailSearchForm>({})
    const salesDetailExportApi = useDownloadSalesDetailApi(salesDetailSearchForm)

    const searchForm = useForm<SalesSearchForm>({ year: Number(moment().format('YYYY')) })
    const salesApi = useFetchSalesApi(searchForm)
    const salesExportApi = useDownloadSalesApi(searchForm)

    useEffectSkipFirst(() => {
        globalState.setLoading(salesApi.loading)
    }, [salesApi.loading])

    useEffect(() => {
        salesApi.execute()
    }, [])

    return (
        <>
            <ContentHeader
                headerTitle="状態別売上"
                left={
                    <ModalButton
                        openButton={<Button>詳細出力</Button>}
                        modalHeader={<>詳細出力</>}
                        modalBody={
                            <div>
                                <SelectField
                                    form={salesDetailSearchForm}
                                    attr="filterType"
                                    label="絞り込み基準"
                                    selectItems={[
                                        { label: '申込日', value: 'post_date' },
                                        { label: '結果票出力日', value: 'send_date' },
                                    ]}
                                    includeBlank
                                />
                                <Flex>
                                    <DateField form={salesDetailSearchForm} attr="start" label="開始日" />
                                    <DateField form={salesDetailSearchForm} attr="end" label="終了日" />
                                </Flex>
                            </div>
                        }
                        submitButton={
                            <Button
                                onClick={() => {
                                    salesDetailExportApi.execute()
                                }}
                            >
                                出力
                            </Button>
                        }
                    />
                }
                right={
                    <Flex>
                        <SelectField form={searchForm} attr="year" selectItems={selectYears()} style={{ marginBottom: 0, width: 120 }} />
                        <Button
                            onClick={() => {
                                salesExportApi.execute()
                            }}
                            style={{ minWidth: 100 }}
                        >
                            Excel出力
                        </Button>
                    </Flex>
                }
            />
            <ContentBody>
                <div>
                    <Table bordered style={{ textAlign: 'center' }}>
                        <thead>
                            <tr>
                                <th rowSpan={2}>年月</th>
                                <th colSpan={2}>申込み</th>
                                <th colSpan={2}>衛生検到着前</th>
                                <th colSpan={2}>衛生検処理中</th>
                                <th colSpan={2}>結果票送付済(売上)</th>
                                <th colSpan={2}>単一がん種売上</th>
                                <th colSpan={2}>複数がん種売上</th>
                                <th colSpan={2}>前受金</th>
                            </tr>
                            <tr>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                                <th>合計金額</th>
                                <th>検体数</th>
                            </tr>
                        </thead>
                        <tbody>
                            {salesApi.response.data?.map((d, index) => {
                                return (
                                    <tr key={'data-' + index}>
                                        <td>{d.date}</td>
                                        <td>{d.fixedPurchasedPrice?.toLocaleString() ?? 0}</td>
                                        <td>{d.fixedPurchasedCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.interviewedPrice?.toLocaleString() ?? 0}</td>
                                        <td>{d.interviewedCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.inProgressPrice?.toLocaleString() ?? 0}</td>
                                        <td>{d.inProgressCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.sales?.toLocaleString() ?? 0}</td>
                                        <td>{d.salesCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.singleCancerSales?.toLocaleString() ?? 0}</td>
                                        <td>{d.singleCancerCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.multiCancerSales?.toLocaleString() ?? 0}</td>
                                        <td>{d.multiCancerCount?.toLocaleString() ?? 0}</td>
                                        <td>{d.advancePayment?.toLocaleString() ?? 0}</td>
                                        <td>{d.nAdvancePayment?.toLocaleString() ?? 0}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </ContentBody>
        </>
    )
}

export default withRouter(SalesPage)
